/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkAlcoGlassWineIcon16Light = forwardRef('FoodDrinkAlcoGlassWineIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2.5A1.5 1.5 0 0 1 3.5 1h8A1.5 1.5 0 0 1 13 2.5v2a5.5 5.5 0 0 1-5 5.478V14h3.5a.5.5 0 0 1 0 1h-8a.5.5 0 0 1 0-1H7V9.978A5.5 5.5 0 0 1 2 4.5v-2ZM3.027 5a4.5 4.5 0 0 0 8.946 0H3.027ZM12 4H3V2.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5V4Z" })));
});
